/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { css } from "styled-components";
import { Button, theme } from "@nordcloud/gnui";

export const MultiSelectButton = styled(Button)`
  border-color: ${theme.color.border.input};
  filter: grayscale(100%);

  ${({ value: selected }) =>
    selected &&
    css`
      border-color: ${theme.color.border.focus};
      filter: none;
    `}

  transition: ${theme.transition};
  margin-right: ${theme.spacing.spacing02};
`;
